/**
 * Compresse une photo côté navigateur avant l'envoi : les téléphones récents
 * produisent des fichiers de plusieurs Mo, largement au-dessus de la limite
 * de 6 Mo acceptée par le serveur et inutiles à cette résolution pour un
 * constat ou une preuve de réparation.
 */
export async function compressImage(file: File): Promise<Blob> {
  const bitmap = await createImageBitmap(file);
  const maximum = 1600;
  const ratio = Math.min(1, maximum / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(bitmap.width * ratio));
  canvas.height = Math.max(1, Math.round(bitmap.height * ratio));
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Compression de la photo impossible.');
  context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close();
  return new Promise((resolve, reject) => canvas.toBlob(
    (blob) => blob ? resolve(blob) : reject(new Error('Compression de la photo impossible.')),
    'image/jpeg',
    0.82,
  ));
}
